<template>
    <div>
        <breadcrumb :links="[{ msg: 'site.contact.us' }]" />
        <contactUsContent />
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import contactUsContent from '@/components/contactUsContent.vue';

export default {
    components: {
        breadcrumb,
        contactUsContent
    }
};
</script>
